<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperHelpDesk',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'HelpDeskModule',
    };
  },
};
</script>
